import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContentHeader from '../components/ContentHeader';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

const OnboardingPage = () => {
    const [orgName, setOrgName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { tenant } = useAuth();
    const navigate = useNavigate();

    if (tenant){
        navigate('/dashboard', {replace: true});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (!orgName.trim()) {
            setError("Organization name is required");
            return;
        }

        setLoading(true);

        const { data, error } = await supabase.functions.invoke('onboarding', {
            body: {
                name: orgName
            },
        })

        if(error) {
            let returned_error = await error.context.json();
            setError(`Error: ${returned_error.error}`);
        }else{
            navigate('/dashboard', {replace: true});
        }

        setLoading(false);
    };

    return (
        <div className="columns has-background-light" style={{ height: '100vh' }}>
            <div className="column is-half  is-offset-one-quarter p-6">
                <ContentHeader title="Create your workspace" subtitle="You need a workspace before submitting benchmarks." />
                <div className="box">
                    <form onSubmit={handleSubmit}>
                        <div className="field">
                            <label className="label">Organization / Team name</label>
                            <div className="control">
                                <input
                                    className="input"
                                    type="text"
                                    placeholder="e.g. ZK Research Lab"
                                    value={orgName}
                                    onChange={(e) => setOrgName(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="notification is-danger is-light" role="alert">
                                <button className="delete" onClick={() => { setError(null) }}></button>
                                {error}
                            </div>
                        )}

                        <div className="field is-grouped is-grouped-right">
                            <div className="control">
                                <button
                                    className={`button is-link ${loading ? "is-loading" : ""
                                        }`}
                                    type="submit"
                                >
                                    Create workspace
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <p className="has-text-centered has-text-grey is-size-7 mt-3">
                    This will create shared storage and benchmarking resources
                    for your team.
                </p>
            </div>
        </div>
    );
};

export default OnboardingPage;
